'use strict';

var _jsx = require('@babel/runtime/helpers/jsx');
var React = require('react');
require('prop-types');
var classnames = require('classnames');
function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
  if (typeof f == "function") {
    var a = function a() {
      if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {
    value: true
  });
  Object.keys(n).forEach(function (k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function () {
        return n[k];
      }
    });
  });
  return a;
}
const RECOMMENDATIONS_HEART_EMPTY = 'recommendations-heart-empty';
const RECOMMENDATIONS_HEART_FULL = 'recommendations-heart-full';
const RECOMMENDATIONS_FULL_ICON = 'recommendations-full_icon';
const RECOMMENDATIONS_CHEVRON = 'recommendations-chevron';
const RECOMMENDATIONS_START_EMPTY = 'recommendations-star-empty';
const RECOMMENDATIONS_START_HALF = 'recommendations-star-half';
const RECOMMENDATIONS_START_FULL = 'recommendations-star-full';
const RECOMMENDATIONS_MELI_LOGO = 'recommendations-meli_logo';
const RECOMMENDATIONS_MELI_COINS = 'recommendations-meli_coins';
const RECOMMENDATIONS_CPG_ICON = 'recommendations-cpg_icon';
const RECOMMENDATIONS_CBT_ICON = 'recommendations-cbt_icon';
const RECOMMENDATIONS_BLACK_FRIDAY_ICON = 'recommendations-black-friday_icon';
const RECOMMENDATIONS_MELICHOICE_LOGO = 'recommendations-melichoice_logo';
const RECOMMENDATIONS_BUFLO_ICON_INFO = 'recommendations-buflo_icon_info';
const RECOMMENDATIONS_MSHOPS_LOGO = 'recommendations-mshops_logo';
const RECOMMENDATIONS_CLOCK_ICON = 'recommendations-clock_icon';
const RECOMMENDATIONS_STORE_ICON = 'recommendations-store_icon';
const RECOMMENDATIONS_FIRE_ICON = 'recommendations-fire_icon';
const RECOMMENDATIONS_BADGE_ICON = 'recommendations-badge_icon';
const RECOMMENDATIONS_INFO_ICON = 'recommendations-info_icon';
const RECOMMENDATIONS_APPAREL_ICON = 'recommendations-clothing_icon';
const RECOMMENDATIONS_BEAUTY_ICON = 'recommendations-beauty_icon';
const RECOMMENDATIONS_TOOLS_ICON = 'recommendations-tools_icon';
const RECOMMENDATIONS_SUPERMARKET_ICON = 'recommendations-super_icon';
const RECOMMENDATIONS_DECO_ICON = 'recommendations-furniture_icon';
var icons = /*#__PURE__*/Object.freeze({
  __proto__: null,
  RECOMMENDATIONS_APPAREL_ICON: RECOMMENDATIONS_APPAREL_ICON,
  RECOMMENDATIONS_BADGE_ICON: RECOMMENDATIONS_BADGE_ICON,
  RECOMMENDATIONS_BEAUTY_ICON: RECOMMENDATIONS_BEAUTY_ICON,
  RECOMMENDATIONS_BLACK_FRIDAY_ICON: RECOMMENDATIONS_BLACK_FRIDAY_ICON,
  RECOMMENDATIONS_BUFLO_ICON_INFO: RECOMMENDATIONS_BUFLO_ICON_INFO,
  RECOMMENDATIONS_CBT_ICON: RECOMMENDATIONS_CBT_ICON,
  RECOMMENDATIONS_CHEVRON: RECOMMENDATIONS_CHEVRON,
  RECOMMENDATIONS_CLOCK_ICON: RECOMMENDATIONS_CLOCK_ICON,
  RECOMMENDATIONS_CPG_ICON: RECOMMENDATIONS_CPG_ICON,
  RECOMMENDATIONS_DECO_ICON: RECOMMENDATIONS_DECO_ICON,
  RECOMMENDATIONS_FIRE_ICON: RECOMMENDATIONS_FIRE_ICON,
  RECOMMENDATIONS_FULL_ICON: RECOMMENDATIONS_FULL_ICON,
  RECOMMENDATIONS_HEART_EMPTY: RECOMMENDATIONS_HEART_EMPTY,
  RECOMMENDATIONS_HEART_FULL: RECOMMENDATIONS_HEART_FULL,
  RECOMMENDATIONS_INFO_ICON: RECOMMENDATIONS_INFO_ICON,
  RECOMMENDATIONS_MELICHOICE_LOGO: RECOMMENDATIONS_MELICHOICE_LOGO,
  RECOMMENDATIONS_MELI_COINS: RECOMMENDATIONS_MELI_COINS,
  RECOMMENDATIONS_MELI_LOGO: RECOMMENDATIONS_MELI_LOGO,
  RECOMMENDATIONS_MSHOPS_LOGO: RECOMMENDATIONS_MSHOPS_LOGO,
  RECOMMENDATIONS_START_EMPTY: RECOMMENDATIONS_START_EMPTY,
  RECOMMENDATIONS_START_FULL: RECOMMENDATIONS_START_FULL,
  RECOMMENDATIONS_START_HALF: RECOMMENDATIONS_START_HALF,
  RECOMMENDATIONS_STORE_ICON: RECOMMENDATIONS_STORE_ICON,
  RECOMMENDATIONS_SUPERMARKET_ICON: RECOMMENDATIONS_SUPERMARKET_ICON,
  RECOMMENDATIONS_TOOLS_ICON: RECOMMENDATIONS_TOOLS_ICON
});
var require$$0 = /*@__PURE__*/getAugmentedNamespace(icons);
var constants = require$$0;
var _g;

// Recommendations-fe Packages
const namespace = 'ui-recommendations-icon';

/* eslint-disable max-len */
const FireIcon = _ref => {
  let {
    className = null
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    className: classnames(namespace, className),
    width: "10",
    height: "11",
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, _g || (_g = /*#__PURE__*/_jsx("g", {
    clipPath: "url(#clip0_241_146626)"
  }, void 0, /*#__PURE__*/_jsx("rect", {
    width: "10",
    height: "10",
    transform: "translate(0 0.375)",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    d: "M9.25146 6.48965C9.25146 4.25052 7.01449 0.885298 7.28197 2.01876C7.74951 4 6.24951 5 5.72434 3.46506C4.74951 0.999142 3.25049 0.50001 3.24951 1.49932C3.249 2.02669 3.45049 3.2 2.25049 3.99999C1.05049 4.79999 0.75114 6.20635 0.751465 6.80953C0.751465 8.60816 1.75748 9.92559 3.26491 10.4944C3.76781 10.7268 5.14822 11.0522 6.64663 10.4944C8.17993 9.8245 9.25146 8.26981 9.25146 6.48965Z",
    fill: "#F23D4F",
    stroke: "#F23D4F",
    strokeWidth: "0.74579"
  }), /*#__PURE__*/_jsx("path", {
    d: "M4.64382 5.73323C4.74295 5.65441 4.92472 5.50152 4.92472 5.50152C5.03226 5.43547 6.8457 7.53875 7.14988 8.04583C7.37189 8.41597 7.54964 8.81987 7.54964 9.27776C7.54964 10.6706 6.37443 11.7998 4.92472 11.7998C3.47502 11.7998 2.2998 10.6706 2.2998 9.27776C2.2998 8.87288 2.57292 8.23715 2.8107 7.88457C3.30222 7.15573 4.19395 6.09093 4.64382 5.73323Z",
    fill: "white"
  }))));
};
const ClockIconMemo = /*#__PURE__*/React.memo(FireIcon);
ClockIconMemo.ICON_ID = constants.RECOMMENDATIONS_FIRE_ICON;
var ClockIconMemo$1 = ClockIconMemo;
module.exports = ClockIconMemo$1;
